/**
 * Payment-terms arithmetic for invoice due dates.
 *
 * Dates are business dates, not instants. The calculation uses UTC midnight so
 * a browser timezone can never move the result by a day, and an invalid or
 * missing issue date returns null rather than inventing a due date.
 */
export function dueDateFromTerms(issueDate: string, days: number): string | null {
  if (!/^\d{4}-\d{2}-\d{2}$/.test(issueDate)) return null;
  if (!Number.isFinite(days) || days < 0) return null;

  const [year, month, day] = issueDate.split("-").map(Number);
  const start = new Date(Date.UTC(year!, month! - 1, day!));
  if (
    Number.isNaN(start.getTime()) ||
    start.toISOString().slice(0, 10) !== issueDate
  ) {
    return null;
  }

  start.setUTCDate(start.getUTCDate() + Math.trunc(days));
  return start.toISOString().slice(0, 10);
}

/** Whole days between two calendar dates, or null when either is invalid. */
export function daysBetween(startDate: string, endDate: string): number | null {
  const start = dueDateFromTerms(startDate, 0);
  const end = dueDateFromTerms(endDate, 0);
  if (!start || !end) return null;
  const startTime = new Date(`${start}T00:00:00Z`).getTime();
  const endTime = new Date(`${end}T00:00:00Z`).getTime();
  return Math.round((endTime - startTime) / 86_400_000);
}
